import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { resolveFetch } from './helper';
export var FunctionsClient = /*#__PURE__*/function () {
  function FunctionsClient(url) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$headers = _ref.headers,
        headers = _ref$headers === void 0 ? {} : _ref$headers,
        customFetch = _ref.customFetch;

    _classCallCheck(this, FunctionsClient);

    this.url = url;
    this.headers = headers;
    this.fetch = resolveFetch(customFetch);
  }
  /**
   * Updates the authorization header
   * @params token - the new jwt token sent in the authorisation header
   */


  _createClass(FunctionsClient, [{
    key: "setAuth",
    value: function setAuth(token) {
      this.headers.Authorization = "Bearer ".concat(token);
    }
    /**
     * Invokes a function
     * @param functionName - the name of the function to invoke
     * @param invokeOptions - object with the following properties
     * `headers`: object representing the headers to send with the request
     * `body`: the body of the request
     * `responseType`: how the response should be parsed. The default is `json`
     */

  }, {
    key: "invoke",
    value: function invoke(functionName, invokeOptions) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _ref2, headers, body, response, isRelayError, data, _ref3, responseType;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _ref2 = invokeOptions !== null && invokeOptions !== void 0 ? invokeOptions : {}, headers = _ref2.headers, body = _ref2.body;
                _context.next = 4;
                return this.fetch("".concat(this.url, "/").concat(functionName), {
                  method: 'POST',
                  headers: Object.assign({}, this.headers, headers),
                  body: body
                });

              case 4:
                response = _context.sent;
                isRelayError = response.headers.get('x-relay-error');

                if (!(isRelayError && isRelayError === 'true')) {
                  _context.next = 13;
                  break;
                }

                _context.t0 = Error;
                _context.next = 10;
                return response.text();

              case 10:
                _context.t1 = _context.sent;
                _context.t2 = new _context.t0(_context.t1);
                return _context.abrupt("return", {
                  data: null,
                  error: _context.t2
                });

              case 13:
                _ref3 = invokeOptions !== null && invokeOptions !== void 0 ? invokeOptions : {}, responseType = _ref3.responseType;

                if (!(!responseType || responseType === 'json')) {
                  _context.next = 20;
                  break;
                }

                _context.next = 17;
                return response.json();

              case 17:
                data = _context.sent;
                _context.next = 35;
                break;

              case 20:
                if (!(responseType === 'arrayBuffer')) {
                  _context.next = 26;
                  break;
                }

                _context.next = 23;
                return response.arrayBuffer();

              case 23:
                data = _context.sent;
                _context.next = 35;
                break;

              case 26:
                if (!(responseType === 'blob')) {
                  _context.next = 32;
                  break;
                }

                _context.next = 29;
                return response.blob();

              case 29:
                data = _context.sent;
                _context.next = 35;
                break;

              case 32:
                _context.next = 34;
                return response.text();

              case 34:
                data = _context.sent;

              case 35:
                return _context.abrupt("return", {
                  data: data,
                  error: null
                });

              case 38:
                _context.prev = 38;
                _context.t3 = _context["catch"](0);
                return _context.abrupt("return", {
                  data: null,
                  error: _context.t3
                });

              case 41:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 38]]);
      }));
    }
  }]);

  return FunctionsClient;
}();